import { BCP } from "../constants/channels";
import { isChannelBcp } from "../utils/channels";

export const GetChannelZohoPhaseOne = (channel: string) => {
    if (isChannelBcp(channel)) {
        return BCP.toUpperCase();
    }
    if (!channel) {
        return "EC";
    }
    return channel;
};
